import { CCol, CRow } from "@coreui/react-pro";
import Header from "../components/Header";
import { useEffect, useState } from "react";
import axios from "@/shared/config/axios-interceptor";
import { formatMoney } from "@/shared/utils/ultils";
const BangBaoCao = () => {
  const [data, setData] = useState<any>();
  const getData = async () => {
    try {
      const res = await axios.get("/transaction/loi-nhuan-lai-lo");
      setData(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  console.log(data);

  return (
    <div className="wrapper">
      <div className="container-web gioithieusanpham bgnew">
        <Header title="Bảng lợi nhuận lãi và lỗ" />

        <main className="p-3">
          <div
            style={{ background: "linear-gradient(0deg,#ceab77,#eddbc1)" }}
            className="text-center py-3 rounded-3 text-black"
          >
            <h6>Số tiền lãi và lỗ</h6>
            <p style={{ color: "#b2812b", fontSize: 18 }}>{formatMoney(Number(data?.tongThuong) + Number(data?.tongLoiNhuan))}</p>
            <p style={{ fontSize: 12, color: "#333" }}>
              {" "}
              Công thức lợi nhuận：Lợi nhuận thu được + Hoàn tiền đầu tư + Hoa
              hồng tích lũy + Chuyển tiền qua thẻ + Quỹ khuyến mãi + Quỹ hoạt
              động - Đầu tư mua
            </p>
          </div>

          <div className="mt-3">
            <CRow className="g-2">
              <CCol xs={4}>
                <div
                  className="px-1 py-3 d-flex flex-column align-items-center justify-content-between rounded-3"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div style={{ color: "#b2812b", fontSize: 16 }}>0</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Lãi lỗ đầu tư
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>0</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Lợi nhuận thu được
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>{formatMoney(data?.guiTietKiem)}</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>Đầu tư mua</div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>{formatMoney(data?.tongLoiNhuan)}</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Hoàn tiền đầu tư
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>{formatMoney(data?.tongThuong)}</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Hoa hồng tích luỹ
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>0</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Số tiền chuyển thẻ
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>0</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Quỹ khuyến mãi
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>0</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>
                    Quỹ hoạt động
                  </div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>{formatMoney(data?.tongRut)}</div>
                  <div style={{ color: "#fff", fontSize: 12 }}>Số tiền rút</div>
                </div>
              </CCol>

              <CCol xs={4}>
                <div
                  className="px-1 rounded-3 text-center h-100 align-content-center"
                  style={{ background: "#524f45", minHeight: 90 }}
                >
                  <div className="truncate-multi-line-1 mb-2" style={{ color: "#b2812b", fontSize: 16 }}>
                    {formatMoney(data?.tongNap)}
                  </div>
                  <div style={{ color: "#fff", fontSize: 12 }}>Số tiền nạp</div>
                </div>
              </CCol>
            </CRow>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BangBaoCao;
